import type React from 'react';
import { registerIsland, registerLazyIsland } from '../registry';
import TestShareButton from '@/components/features/test/TestShareButton/TestShareButton';
import TestFavoriteButton from '@/components/features/test/TestFavoriteButton/TestFavoriteButton';

type AnyIsland = React.ComponentType<Record<string, unknown>>;

// ── Eager: маленькие острова, которые монтируются сразу при загрузке страницы
//    (кнопки share/favorite над картинкой теста). Их код должен быть в основном
//    чанке, чтобы не мигали Suspense-ом над сгибом.
registerIsland('TestShareButton',    TestShareButton    as unknown as AnyIsland);
registerIsland('TestFavoriteButton', TestFavoriteButton as unknown as AnyIsland);

// ── Lazy: тяжёлые/по-требованию острова. Каждый — отдельный чанк, грузится при
//    первом монтировании (под <Suspense>). Раньше все они лежали в едином
//    бандле и парсились на каждой странице с островами (в т.ч. на стартовом
//    экране теста, где нужен лишь TestProcess по клику) — лишний INP/TBT.
registerLazyIsland('TestProcess',  () => import('./TestProcessIsland'));
registerLazyIsland('TestResult',   () => import('@/components/features/result/TestResultIsland/TestResultIsland'));
registerLazyIsland('HistoryModal', () => import('@/components/features/result/HistoryIslandModal/HistoryIslandModal'));
registerLazyIsland('TestQualityModal', () => import('@/components/features/test/TestQuality/TestQualityModal'));
registerLazyIsland('EmbedTest',    () => import('@/components/features/widgets/EmbedTestIsland/EmbedTestIsland'));
registerLazyIsland('WidgetModal',  () => import('@/components/features/widgets/WidgetModalIsland/WidgetModalIsland'));
registerLazyIsland('WidgetManual', () => import('@/components/features/widgets/WidgetManual/WidgetManual'));
registerLazyIsland('WidgetPricing', () => import('@/components/features/widgets/WidgetPricing/WidgetPricing'));
registerLazyIsland('Profile',      () => import('./ProfileIsland'));
registerLazyIsland('RecommendedTests', () => import('@/components/features/glossary/RecommendedTests/RecommendedTests'));
registerLazyIsland('Contacts',     () => import('./ContactsIsland'));
